import { useSelector } from 'react-redux';

import { NewReviewButtonContainer } from '../NewReviewButton';
import { NoReviews } from '../../components/NoReviews';
import { getObjectInfo } from '../../selectors/objectInfo';
import { NewQuestionButtonContainer } from '../NewQuestionButton';

export function NoReviewsContainer() {
  const { objectName } = useSelector(getObjectInfo);

  return (
    <NoReviews
      newbuildingName={objectName}
      newReviewButton={<NewReviewButtonContainer size="XS" fullWidth={false} />}
      newQuestionButton={<NewQuestionButtonContainer size="XS" fill="fill_secondary" fullWidth={false} />}
    />
  );
}
